export const subscriberPageTranslations = {
  en: {
    subscriberPage: {
      birthDate: 'Birth date',
      employmentStatus: 'Employment status',
      finish: 'Finish adding card',
      firstName: 'First name',
      lastName: 'Last name',
      mailingAddress: 'Mailing address',
      mobilePhoneNumberOptional: 'Mobile phone number (optional)',
      moreInformation: 'More information',
      notSureQuestion: 'Not sure?',
      primaryPolicyHolderEmployer: 'Employer',
      patientRelationshipToPrimaryPolicyholderTitle:
        'How is the patient related to the person who owns the insurance policy?',
      patientRelationshipToPrimaryPolicyholder:
        "This person is the patient's...",
      primaryPolicyHolderRelationshipToPatient:
        "This patient is the person's...",
      self: 'Self',
      sex: 'Sex',
      someoneElse: 'Someone else',
      title: 'Please select or add the policyholder for this new card.',
      whoIsPolicyholderQuestion: 'Who is the insurance policyholder?',
    },
  },
  es: {
    subscriberPage: {
      birthDate: 'Fecha de nacimiento',
      employmentStatus: 'Estado laboral',
      finish: 'Terminar de agregar la tarjeta',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      mailingAddress: 'Dirección de envio',
      mobilePhoneNumberOptional: 'Número de teléfono celular (opcional)',
      moreInformation: 'Más información',
      notSureQuestion: '¿No estoy segura?',
      primaryPolicyHolderEmployer: 'Empleador',
      patientRelationshipToPrimaryPolicyholderTitle:
        '¿Cómo se relaciona el paciente con la persona propietaria de la póliza de seguro?',
      patientRelationshipToPrimaryPolicyholder:
        'Esta persona, en su relación con el paciente, ocupa el rol de...',
      self: 'Titular',
      sex: 'Sexo',
      someoneElse: 'Alguien más',
      title:
        'Seleccione o agregue el titular de la póliza para esta nueva tarjeta.',
      whoIsPolicyholderQuestion: '¿Quién es el asegurado?',
    },
  },
  ru: {
    subscriberPage: {
      primaryPolicyHolderEmployer: 'Работодатель',
      firstName: 'Имя',
      lastName: 'Фамилия',
    },
  },
  ht: {
    subscriberPage: {
      primaryPolicyHolderEmployer: 'Patwon, Anplwayè',
      firstName: 'Prenon ou',
      lastName: 'Siyati ou',
    },
  },
  km: {
    subscriberPage: {
      lastName: 'នាមត្រកូល',
    },
  },
  pt: {
    subscriberPage: {
      birthDate: 'Data de nascimento',
      employmentStatus: 'Situação de emprego',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      mailingAddress: 'Endereço para correspondência',
      mobilePhoneNumberOptional: 'Número de celular (opcional)',
      moreInformation: 'Mais Informações',
      patientRelationshipToPrimaryPolicyholderTitle:
        'Qual é a relação entre o paciente e o titular da apólice de seguro?',
      patientRelationshipToPrimaryPolicyholder: 'Essa pessoa é...',
      self: 'O próprio paciente',
      sex: 'Sexo',
      someoneElse: 'Outra pessoa',
      title: 'Selecione ou adicione o segurado para este novo cartão.',
      whoIsPolicyholderQuestion: 'Quem é o segurado?',
    },
  },
  bn: {
    subscriberPage: {
      birthDate: 'জন্ম তারিখ',
      employmentStatus: 'কর্মসংস্থানের অবস্থা',
      firstName: 'নাম',
      lastName: 'পদবি',
      mailingAddress: 'চিঠি পাঠানোর ঠিকানা',
      mobilePhoneNumberOptional: 'মোবাইল ফোন নম্বর (ঐচ্ছিক)',
      moreInformation: 'আরও তথ্য',
      patientRelationshipToPrimaryPolicyholderTitle:
        'যে ব্যক্তি বীমা পলিসি করিয়েছেন, তার সাথে রোগীর সম্পর্ক কী?',
      patientRelationshipToPrimaryPolicyholder: 'এই ব্যক্তি হল রোগীর...',
      self: 'নিজে রোগী',
      sex: 'লিঙ্গ',
      someoneElse: 'অন্য কেউ',
      title: 'অনুগ্রহ করে এই নতুন কার্ডের পলিসিহোল্ডার বেছে নিন বা যোগ করুন।',
      whoIsPolicyholderQuestion: 'বীমার পলিসিহোল্ডার কে?',
    },
  },
  ja: {
    subscriberPage: {
      birthDate: '生年月日',
      employmentStatus: '雇用状況',
      firstName: '名',
      lastName: '姓',
      mailingAddress: '住所',
      mobilePhoneNumberOptional: '携帯電話番号（任意）',
      moreInformation: '詳細情報',
      patientRelationshipToPrimaryPolicyholderTitle:
        '保険契約者様と患者様の関係',
      patientRelationshipToPrimaryPolicyholder: '保険契約者様は患者様の...',
      self: '本人',
      sex: '性別',
      someoneElse: '別のかた',
      title: 'この新しい保険証の契約者を選択または追加してください。',
      whoIsPolicyholderQuestion: '保険契約者とは誰を指しますか？',
    },
  },
  ko: {
    subscriberPage: {
      birthDate: '생년월일',
      employmentStatus: '고용 상태',
      firstName: '이름',
      lastName: '성',
      mailingAddress: '우편 주소',
      mobilePhoneNumberOptional: '휴대전화 번호(선택 사항)',
      moreInformation: '추가 정보',
      patientRelationshipToPrimaryPolicyholderTitle:
        '환자와 보험증서를 소유한 사람과의 관계는 어떻게 되나요?',
      patientRelationshipToPrimaryPolicyholder: '이 사람은 환자의...',
      self: '본인',
      sex: '성별',
      someoneElse: '다른 누군가',
      title: '이 새 카드의 보험 계약자를 선택 혹은 추가해 주십시오.',
      whoIsPolicyholderQuestion: '보험 계약자는 누구입니까?',
    },
  },
  ro: {
    subscriberPage: {
      birthDate: 'Data de naștere',
      employmentStatus: 'Statutul de angajare',
      firstName: 'Nume',
      lastName: 'Prenume',
      mailingAddress: 'Adresa poștală',
      mobilePhoneNumberOptional: 'Numărul de telefon mobil (opțional)',
      moreInformation: 'Mai multe detalii',
      patientRelationshipToPrimaryPolicyholderTitle:
        'Cum se raportează pacientul cu persoana care deține polița de asigurare?',
      patientRelationshipToPrimaryPolicyholder:
        'Această persoană se raportează pacientului...',
      self: 'Pacientul',
      sex: 'Sex',
      someoneElse: 'Altcineva',
      title:
        'Vă rugăm să selectați sau să adăugați titularul poliței pentru acest nou card.',
      whoIsPolicyholderQuestion: 'Cine este deținătorul poliței de asigurare?',
    },
  },
  zh: {
    subscriberPage: {
      birthDate: '出生日期',
      employmentStatus: '就业状态',
      firstName: '名字',
      lastName: '姓氏',
      mailingAddress: '邮寄地址',
      mobilePhoneNumberOptional: '移动电话号码（选填）',
      moreInformation: '更多信息',
      patientRelationshipToPrimaryPolicyholderTitle:
        '患者与拥有保险单的人员有何关系？',
      patientRelationshipToPrimaryPolicyholder: '此人员是患者……',
      self: '自己',
      sex: '性别',
      someoneElse: '其他人',
      title: '请选择或添加此新卡的保单持有人。',
      whoIsPolicyholderQuestion: '谁是保单持有人？',
    },
  },
};
